export default __webpack_public_path__ + "static/media/O-097.9564b3ed.png";